import { Box, Tab } from '@chakra-ui/react'
import { ReactElement } from 'react'

const StyledTab = ({
  children,
  hasExclamation,
  extra,
  onClick,
  isSelected,
}: {
  children: ReactElement | string
  hasExclamation?: boolean
  extra?: ReactElement | string
  onClick?: () => void
  isSelected?: boolean
}) => {
  return (
    <Tab
      onClick={onClick}
      _active={isSelected ? { bg: 'neutral.100' } : {}}
      _selected={{
        borderColor: 'secondary.500',
        fontWeight: '500',
        color: 'neutral.900',
      }}
      color="neutral.600"
      textStyle="b-sm"
      fontWeight="400"
    >
      {children}
      {hasExclamation && <Box w="6px" h="6px" bg="red.500" ml="12px" borderRadius="50%" />}
      {extra && <>{extra}</>}
    </Tab>
  )
}

export default StyledTab
